export default __webpack_public_path__ + "static/media/location.b0a46e4f.png";